import { ATTENTION_ITEMS_MAX, ATTENTION_KIND_LABEL, SEVERITY_COLOR } from "../../lib/mkBoardView";
import { CHANNEL_COLOR, CHANNEL_LABEL } from "../../lib/mkRules";
import type { BoardAttention } from "../../types/contract";

interface AttentionCardProps {
  attention: BoardAttention;
  onOpen: (initiativeId: string) => void;
  onDismiss: (id: string) => void;
}

/**
 * 判断が必要なもの（カードにするのはブリーフとこれだけ）。推奨（太字1文）が最も目立つ。
 * 「済みにする」は任意（条件が消えれば押さなくても自動で消える）なので目立たないテキストリンク。
 */
export function AttentionCard({ attention: a, onOpen, onDismiss }: AttentionCardProps) {
  const extra = Math.max(0, a.items.length - ATTENTION_ITEMS_MAX);
  return (
    <article className="mk2-att" style={{ borderLeftColor: SEVERITY_COLOR[a.severity] }}>
      <div className="mk2-att-top">
        {a.channel && (
          <>
            <span className="mk2-chdot" style={{ background: CHANNEL_COLOR[a.channel] }} />
            <span className="mk2-att-ch" style={{ color: CHANNEL_COLOR[a.channel] }}>
              {CHANNEL_LABEL[a.channel]}
            </span>
          </>
        )}
        <span className="mk2-att-kind">{ATTENTION_KIND_LABEL[a.kind]}</span>
        {!a.ai_written && <span className="mk2-tag mk2-att-rule">ルール判定</span>}
      </div>
      <h3 className="mk2-att-title">{a.title}</h3>
      <p className="mk2-att-rec">
        <span className="mk2-att-label">推奨</span>
        {a.recommendation}
      </p>
      <p className="mk2-att-reason">
        <span className="mk2-att-label">根拠</span>
        {a.reason}
      </p>
      {a.items.length > 0 && (
        <ul className="mk2-att-items">
          {a.items.slice(0, ATTENTION_ITEMS_MAX).map((it, i) => (
            <li key={i}>{it}</li>
          ))}
          {extra > 0 && <li className="mk2-att-more">ほか{extra}件</li>}
        </ul>
      )}
      <div className="mk2-att-actions">
        {a.initiative_id && (
          <button type="button" className="mk2-btn-sm" onClick={() => a.initiative_id && onOpen(a.initiative_id)}>
            詳細
          </button>
        )}
        <button type="button" className="mk2-link-btn" onClick={() => onDismiss(a.id)}>
          済みにする
        </button>
      </div>
    </article>
  );
}
